<template>
  <div class="cool-image-widget-container" @click="handleClick">
    <ComponentWrap
      :config="detail.config"
      :styles="detail.styles">
      <img class="img-item" :src="imageSrc"/>
    </ComponentWrap>
  </div>
</template>

<script>
import { ComponentWrap, pubSub } from '@igetcool/cool-mobile-ui';
import { ImagePreview } from 'vant';
import { env } from '@utils';
import { getUrlParam } from '@utils/common';
import { findComponentUpwardByName } from '@utils/tool';

export default {
  name: 'CourseImg',
  data() {
    return {
      showSecond: false
    };
  },
  props: {
    detail: Object,
    activityName: String,
    index: Number
  },
  computed: {
    imageSrc() {
      let { contents: { image, image2 = {}, needSecond = false } } = this.detail;
      const realShowSecondImage = image2.src && needSecond && this.showSecond;
      return realShowSecondImage ? image2.src : image.src;
    }
  },
  methods: {
    splitIgcfrom(url) {
      const igcFrom = this.$route.query.igc_from;
      if (!url || !igcFrom) { return url }

      let arr = url.split('?');
      if (arr.length > 1) {
        // @aigc:start 2024/04/08-16:59
        // 将arr1转为对象
        let obj = {};
        arr[1].split('&').forEach(item => {
          let [key, value] = item.split('=');
          obj[key] = value;
        });
        // @aigc:end 2024/04/08-16:59

        // @aigc:start 2024/04/08-17:03
        // 判断obj中是否有igc_from，没有则添加
        if (!obj.igc_from || obj.igc_from == 'xxx') {
          obj.igc_from = igcFrom;
        }
        // @aigc:end 2024/04/08-17:03

        // @aigc:start 2024/04/08-17:08
        // 将对象转为字符串
        let str = [];
        for (let key in obj) {
          str.push(`${key}=${obj[key]}`);
        }
        str = str.join('&');
        url = arr[0] + '?' + str;
        // @aigc:end 2024/04/08-17:08
      } else {
        url += '?igc_from=' + igcFrom;
      }

      return url;
    },
    handleClick() {
      const { clickType, imgHyperLink, bigImage, jumpType } = this.detail.contents;
      // clickType 0: 无 100: 商城商品 101: 超链接 102: 设置购买  103:显示大图
      // 100: 商城商品 ==》 1:跳转商品 2: 跳转拼团 3:跳转小货架 4:跳转前置优惠券
      if (clickType === '101') {
        this.emitEvent({ action: 'jump', url: this.splitIgcfrom(imgHyperLink) });
      } else if (clickType === '102') {
        this.emitEvent({ action: 'buy' });
      } else if (clickType === '103' && bigImage) {
        if (env.isWeChat) {
          WeixinJSBridge.invoke('imagePreview', {
            'urls': [bigImage]
          });
        } else {
          ImagePreview({
            images: [bigImage],
            showIndex: false,
            closeable: true
          });
        }

        this.emitEvent({ action: 'preview' });
      } else if (clickType === '100' && imgHyperLink) {
        const { linkType } = getUrlParam(imgHyperLink);
        let url = linkType == 3 ? `/mall/shoppingPolymerize${imgHyperLink}` : `/mall/course${imgHyperLink}`;

        if (linkType == 3) {
          url = `/mall/shoppingPolymerize${imgHyperLink}`;
        } else if (linkType == 5) {
          url = `/mall/combine${imgHyperLink}`;
        } else if (linkType == 9) {
          url = `/mall/circle${imgHyperLink}`;
        } else if (linkType == 8) {
          url = `/mall/vipCard${imgHyperLink}`;
        } else if (linkType == 10) {
          url = `/mall/camp${imgHyperLink}`;
        } else {
          url = `/mall/course${imgHyperLink}`;
        }

        this.emitEvent({ action: 'jump', url: this.splitIgcfrom(url) });
      }
    },
    emitEvent({ action, url }) {
      const whitePage = ['courseItem', 'shoppingPolymerize', 'vipCard', 'AiCircle'];
      let name = this.$route.name;
      if (!whitePage.includes(name)) {
        return;
      }

      if (name == 'courseItem') {
        name = 'goodItem';
      } else if (name == 'shoppingPolymerize') {
        name = 'Polymerize';
      } else if (name === 'vipCard') {
        name = 'VipCard';
      }

      const parent = findComponentUpwardByName(this, name);
      if (!parent) {
        return;
      }

      let otherParams = {};
      if (this.detail.contents.moduleName) {
        otherParams.module_name = this.detail.contents.moduleName;
      }
      if (this.detail.contents.imgName) {
        otherParams.btn_name = this.detail.contents.imgName;
      }

      parent.setLogTrack && parent.setLogTrack({
        wedget_index: this.index,
        wedget_type: this.detail.widgetType,
        module_name: '图片组件',
        ...otherParams,
        key1: {
          clickType: this.detail.contents.clickType,
          jumpType: this.detail.contents.clickType == 100 ? this.detail.contents.jumpType : '',
        }
      }, 'click');

      if (action === 'buy') {
        parent.openHandle && parent.openHandle({ imgClick: true });
      } else if (action === 'jump' && url) {
        if (parent.goTo) {
          const { isOpenNewPage, clickType } = this.detail.contents;
          if (isOpenNewPage == 1 && !url.startsWith('http') && clickType == 100) {
            url = window.location.origin + url;
          }
          parent.goTo(url, isOpenNewPage);
        } else {
          window.location.href = url;
        }
      }
    }
  },
  components: {
    ComponentWrap,
  }
};
</script>

<style lang="stylus" scoped>
.cool-image-widget-container
  position relative
  img.img-item
    display block
    width 100%
    -webkit-backface-visibility: hidden;
</style>
